import script from "./reservationDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./reservationDialog.vue?vue&type=script&setup=true&lang=js"

import "./reservationDialog.vue?vue&type=style&index=0&id=f469a31c&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/web-h5-hade/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f469a31c"]])

export default __exports__